import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'

var firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyBvbgnksPKifXn5ymgQ6ahfcITv25ULGRc',
  authDomain: 'nunav-pragya.firebaseapp.com',
  databaseURL: 'https://nunav-pragya.firebaseio.com',
  projectId: 'nunav-pragya',
  storageBucket: 'nunav-pragya.appspot.com',
  messagingSenderId: '124042627833'
})

const db = firebaseApp.database()
const auth = firebaseApp.auth()
const storage = firebaseApp.storage()

export { db, auth, storage }



// WEBPACK FOOTER //
// ./src/firebase.js